import React from 'react';
import PropTypes from 'prop-types';
import { jobsTabs } from '../../config/constants';
import './style.css';

const EMPTY_STATE_CONFIG = {
  [jobsTabs.ACTIVE]: {
    icon: 'csv',
    titleKey: 'export:noRecentJobs',
    descriptionKey: 'export:noRecentJobsDescription',
    variant: 'active',
  },
  [jobsTabs.FAVORITES]: {
    icon: 'star_outline',
    titleKey: 'export:noFavoriteJobs',
    descriptionKey: 'export:noFavoriteJobsDescription',
    variant: 'favorites',
  },
  [jobsTabs.ARCHIVED]: {
    icon: 'inventory_2',
    titleKey: 'export:noArchivedJobs',
    descriptionKey: 'export:noArchivedJobsDescription',
    variant: 'archived',
  },
};

const ExportEmptyState = ({ tab, t, onCreateNew }) => {
  const config = EMPTY_STATE_CONFIG[tab] || EMPTY_STATE_CONFIG[jobsTabs.ACTIVE];

  return (
    <div className={`export-empty-state export-empty-state--${config.variant}`}>
      <div className="export-empty-illustration">
        <div className="export-empty-icon">
          <span className="material-symbols-outlined">{config.icon}</span>
        </div>
        <div className="export-empty-ripple export-empty-ripple-1" />
        <div className="export-empty-ripple export-empty-ripple-2" />
        <div className="export-empty-ripple export-empty-ripple-3" />
      </div>
      <h3 className="export-empty-title">
        {t(config.titleKey)}
      </h3>
      <p className="export-empty-description">
        {t(config.descriptionKey)}
      </p>
      {tab === jobsTabs.ACTIVE && onCreateNew && (
        <button
          type="button"
          className="export-empty-cta"
          onClick={onCreateNew}
        >
          <span className="material-symbols-outlined">add</span>
          {t('export:createNewExportJob')}
        </button>
      )}
    </div>
  );
};

ExportEmptyState.propTypes = {
  tab: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onCreateNew: PropTypes.func,
};

ExportEmptyState.defaultProps = {
  onCreateNew: null,
};

export default ExportEmptyState;
